import {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {
  HistoryComponent,
  HistoryComponentProps,
} from 'src/components/elements/account/newHistoryUI/historyComponent';

const MobilePurchaseList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.mobilePurchase;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'MobilePurchaseList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return (
    <HistoryComponent historyfilter={filterTypes.mobilePurchase} {...props} />
  );
};

export default MobilePurchaseList;
